import first from 'lodash/first'
import isArray from 'lodash/isArray'

const getFirst = <T>(value: T | T[]) => (isArray(value) ? first(value) : value)

export default getFirst
